import {
	AfterViewInit,
	Component,
	ElementRef,
	Input,
	OnChanges,
	OnInit,
	SimpleChanges,
	ViewChild,
} from "@angular/core";
// @ts-ignore
import Swiper from "swiper";
import { register, SwiperContainer } from "swiper/element/bundle";
import { SliderWebAyService } from "@shared-ay/slider-web-ay/slider-web-ay.service";

register();

@Component({
	standalone: false,
	selector: "slider-web-ay",
	templateUrl: "./slider-web-ay.component.html",
	styleUrls: ["./slider-web-ay.component.scss"],
})
export class SliderWebAyComponent implements OnInit, AfterViewInit, OnChanges {
	/**@description - Optional , Swiper options
	 * */
	@Input() options?: SliderAyOptions;
	/**
	 * @description - Name of slider to ref with multiple instance in same page
	 * @example - SliderSoinsNomenclature
	 * */
	@Input() sliderRefName;
	@Input() nbSlides: number;
	@ViewChild("swiperRef", { static: true })
	protected _swiperRef: ElementRef;

	swiper?: Swiper;

	constructor(private SliderService: SliderWebAyService) {}

	ngOnInit() {
		if (this.sliderRefName === null || this.sliderRefName === undefined) {
			throw new TypeError("The Input 'sliderRefName' is required !");
		}
	}

	ngAfterViewInit(): void {
		const swiperEl = document.querySelector(`.${this.sliderRefName}  swiper-container`) as SwiperContainer;
		this.swiper = this.SliderService.initSwiper(swiperEl, this.sliderRefName, this.options);
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.nbSlides.previousValue !== changes.nbSlides.currentValue) {
			setTimeout(() => {
				this.swiper?.update();
			}, 50); // To update bullets after slides number change (delay required to let the template finishes its update)
		}
	}
}

export interface SliderAyOptions {
	navigation?: boolean;
	customNavigation?: boolean;
	mouseWheel?: boolean;
	pagination?: boolean;
	bulletIndex?: boolean;
	slidesPerView?: number;
}
